module.exports = __webpack_public_path__ + "static/media/bengoshi.com.9e405ba8.png";


//////////////////
// WEBPACK FOOTER
// ./src/presentation/assets/img/bengoshi.com.png
// module id = 530
// module chunks = 0